import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2023 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import { AutoComplete as RSAutoComplete } from "rsuite";
import { RSForm } from "../index";
function AutoComplete(props) {
    const { label, data, value, onChange } = props;
    return (_jsxs("div", { children: [label && _jsx(RSForm.ControlLabel, { children: label }), _jsx(RSAutoComplete, { data: data, value: value, onChange: onChange })] }));
}
export default AutoComplete;
